import { createSelector } from 'reselect';

const selectQuotes = (state: any) => state.quotes;

export const selectQuotesCurrentItem = createSelector([selectQuotes], (quotes) => quotes.current);

export const selectQuotesListItems = createSelector([selectQuotes], (quotes) => quotes.list);

export const selectQuotesItemById = (itemId: any) =>
    createSelector(selectQuotesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectQuotesQueryItems = createSelector([selectQuotes], (quotes) => quotes.query);

export const selectQuotesCreatedItem = createSelector([selectQuotes], (quotes) => quotes.create);

export const selectQuotesUpdatedItem = createSelector([selectQuotes], (quotes) => quotes.update);

export const selectQuotesReadItem = createSelector([selectQuotes], (quotes) => quotes.read);

export const selectQuotesDeletedItem = createSelector([selectQuotes], (quotes) => quotes.delete);

export const selectQuotesSearchedItems = createSelector([selectQuotes], (quotes) => quotes.search);

export const selectQuotesItemsCount = createSelector([selectQuotes], (quotes) => quotes.count);

export const selectQuotesItemsFilter = createSelector([selectQuotes], (quotes) => quotes.filter);